// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const necrozma_dawn: PokeData = {
  "id": 10156,
  "name": "necrozma-dawn",
  "height": 42,
  "weight": 3500,
  "base_experience": 340,
  "types": [
    PokeType.PSYCHIC,
    PokeType.GHOST
  ],
  "api_moves": [
    "confusion",
    "slash",
    "metal-claw",
    "morning-sun",
    "moonlight",
    "iron-defense",
    "rock-blast",
    "gravity",
    "wring-out",
    "night-slash",
    "power-gem",
    "psycho-cut",
    "mirror-shot",
    "stealth-rock",
    "charge-beam",
    "autotomize",
    "stored-power",
    "prismatic-laser",
    "photon-geyser"
  ],
  "moves": [
    "metal-claw",
    "morning-sun",
    "moonlight",
    "rock-blast",
    "night-slash",
    "stealth-rock",
    "reflect",
    "poltergeist",
    "synchronize",
    "calm-mind",
    "spectral-chain",
    "shadow-dagger",
    "psychic-terrain"
  ],
  "evolution_chain": {
    "id": 421,
    "item": null,
    "species": [
      {
        "name": "necrozma",
        "order": 800,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 90,
    "ability_power": 184
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
